<script setup>
import { SwButton, SwText } from '@getswish/design-library-web';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ModalLayout from '@/_company/components/ModalLayout.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },

  message: {
    type: String,
    default: '',
  },

  confirmText: {
    type: String,
    default: '',
  },

  cancelText: {
    type: String,
    default: '',
  },

  hideCancelButton: {
    type: Boolean,
    default: false,
  },

  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
const confirm = computed(() => props.confirmText || t('common.yes'));
const cancel = computed(() => props.cancelText || t('common.cancel'));
</script>

<template>
  <ModalLayout @onClose="$emit('cancel')">
    <template v-slot:header>
      <SwText element="h2" variant="tertiary-title-medium" align="center">
        {{ title }}
      </SwText>
    </template>

    <template v-slot:body>
      <div>
        <SwText align="center">
          {{ message }}
        </SwText>
      </div>
    </template>

    <template v-slot:footer>
      <SwButton :label="confirm" :is-loading="isLoading" @click="$emit('confirm')" />
      <SwButton
        v-if="!hideCancelButton"
        :label="cancel"
        variant="secondary"
        @click="$emit('cancel')"
      />
    </template>
  </ModalLayout>
</template>
